export const flex: React.CSSProperties = {
  display: 'flex',
};

export const flexColumn: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
};
